import React from "react";
import "./Settings.scss";

const OrganizationInfo = ({ organisationDetails }) => {
  const getOrgCategory = (() => {
    try {
      return typeof organisationDetails.category === "string"
        ? JSON.parse(organisationDetails.category)?.label
        : organisationDetails.category?.label;
    } catch (error) {
      return "";
    }
  })();
  return (
    <div>
      <div className="profile-form-container">
        <ul className="form-list">
          <li>
            <label>Organization Name</label>
            <span>{organisationDetails.name}</span>
          </li>
          <li>
            <label>Category</label>
            <span>{getOrgCategory}</span>
          </li>
          <li>
            <label>Organization Website</label>
            <span>{organisationDetails.link}</span>
          </li>
          <li>
            <label>Country</label>
            <span>{organisationDetails.country_code}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default OrganizationInfo;
